import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "toast-content" }
const _hoisted_3 = { class: "toast-icon" }
const _hoisted_4 = {
  key: 0,
  src: "/icons/icon-success.svg",
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: "/icons/icon-fail.svg",
  alt: ""
}
const _hoisted_6 = {
  key: 2,
  src: "/icons/icon-warning.svg",
  alt: ""
}
const _hoisted_7 = {
  key: 3,
  src: "/icons/icon-info.svg",
  alt: ""
}
const _hoisted_8 = { class: "toast-message" }
const _hoisted_9 = ["onClick"]

import { useToastStore } from '@/stores/toast.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalToastContainer',
  setup(__props) {

const toastStore = useToastStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toastStore).toasts, (toast) => {
    return (_openBlock(), _createBlock(_Transition, {
      key: toast.id,
      name: "toast"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["toast-container", `toast-${toast.type}`]),
          onClick: ($event: any) => (_unref(toastStore).remove(toast.id))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (toast.type === 'success')
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : (toast.type === 'error')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : (toast.type === 'warning')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", _hoisted_7))
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(toast.message), 1),
            _createElementVNode("button", {
              class: "toast-close",
              onClick: _withModifiers(($event: any) => (_unref(toastStore).remove(toast.id)), ["stop"])
            }, "×", 8, _hoisted_9)
          ])
        ], 10, _hoisted_1)
      ]),
      _: 2
    }, 1024))
  }), 128))
}
}

})